/*
  /women トップの土台 (2026-10-09 オーナー決定 案B + 案C)。
  色、字、余白、罫の値は開発演習の LP (lp/prod-dev.page.tsx の CSS) から写した。
  各節はここの変数と .hx- の部品クラスだけを使う。値を足すときはこのファイルに足す。

  変数は次の通り (.hp の上に置く)。
  - 地は cream (--cream)、青みの白 (--blue-wash)、白を交互に。白を2つ続けない
  - 字は墨 (--ink)、補助は --sub。明るい面の強調は青 (--blue) が主。黄 (--yellow) は黒の面、ヘッダーのボタン、箱の見出し (hx-bands)、表の主役の札とマーカー
  - 罫は墨の細い線が主。表の中だけ --line の薄い灰
  - 余白は節が --sec (64、900px から 88)、物と見出しが --gap (40、900px から 48)。値は hp-css.ts の .hp に置いてある

  部品は app/pages/index/parts.tsx の Sec、SectionHead、BrowserFrame、PhotoBand、PullQuote、Quote、ApplyPill、Signature。
  使い方は各部品の頭に書いてある。字は app.css が body * に var(--font-body-ja) を !important で当てているので、
  明朝と等幅は font-family ではなく --font-body-ja を置き直して切り替える (.hp-mi、.hp-mono、各クラスの中)。
  書体は3つだけ。ゴシックは Noto Sans JP の 400、700、900 だけ (--gothic、開発演習の LP と同じ。fallback は app.css の --font-sans-ja)、明朝は Noto Serif JP の 700 と、スマホの節の見出しだけの 900、等幅は IBM Plex Mono の 400 と 600 だけで英字のラベルと数字にだけ使う (日本語の文には使わない)
*/
import { planColorCss } from "../../components/PlanIcon";
export const BASE_CSS = `
.hp{--focus-ring:#14231A;--blue:#1F56D6;--blue-wash:#EAF0FD;--blue-soft:#9DB8F5;--cream:#FBF6EC;--black:#0E0E10;--yellow:#FFE566;--line:#D9D9D9;--red:#C7343A;--green:#30A46C}
/* focus の輪は 1 か所のこの変数だけ。明るい地は墨、暗い地 (黒の帯、青の地、最初の画面) は黄 */
.hp .hx-dark,.hp .hx-blue,.hp .hp-fv{--focus-ring:var(--yellow)}
/* 節の見出し (h2) の大きさは2通りだけ。大は主な節、小は補助の節 (声、一緒に開発)。箱の見出しは大。値はここだけに置く */
.hp{--h2-l:clamp(28px,8vw,32px);--h2-s:clamp(22px,6.4vw,26px)}
@media (min-width:900px){.hp{--h2-l:clamp(38px,3.6vw,48px);--h2-s:clamp(30px,2.8vw,36px)}}
/* 節の見出しの太さ。スマホは小さい画面で一瞬で読ませるために太くし、PC は今のまま (700)。値はここだけに置く */
.hp{--h2-w:900}
@media (min-width:900px){.hp{--h2-w:700}}

/* 節の地と余白。font-size は節の中の基準 */
.hp .hx-sec{padding-top:var(--sec);padding-bottom:var(--sec);font-size:15px;line-height:1.8;color:var(--ink)}
.hp .hx-pt0{padding-top:0}
.hp .hx-pb0{padding-bottom:0}
/* クリームの地は方眼の線を引く。値は開発演習の LP の BRICK と BRICK_LINES (lp/meta/campaign/t2-parts.tsx) から写した。中身は線より前に出す */
.hp .hx-cream{position:relative;background-color:var(--cream);background-image:repeating-linear-gradient(0deg,transparent 0 35px,rgba(24,24,24,.04) 35px 36px)}
.hp .hx-cream::before,.hp .hx-cream::after{content:"";position:absolute;inset:0;pointer-events:none}
.hp .hx-cream::before{background-image:repeating-linear-gradient(90deg,rgba(24,24,24,.035) 0 1px,transparent 1px 80px);-webkit-mask-image:repeating-linear-gradient(0deg,#181818 0 36px,transparent 36px 72px);mask-image:repeating-linear-gradient(0deg,#181818 0 36px,transparent 36px 72px)}
.hp .hx-cream::after{background-image:repeating-linear-gradient(90deg,transparent 0 40px,rgba(24,24,24,.035) 40px 41px,transparent 41px 80px);-webkit-mask-image:repeating-linear-gradient(0deg,transparent 0 36px,#181818 36px 72px);mask-image:repeating-linear-gradient(0deg,transparent 0 36px,#181818 36px 72px)}
.hp .hx-cream>*{position:relative}
.hp .hx-white{background:#fff}
.hp .hx-wash{background:var(--blue-wash)}
.hp .hx-dark{background:var(--black);color:#fff}
.hp .hx-wrap{max-width:1120px;margin:0 auto;padding:0 20px}
@media (min-width:900px){.hp .hx-wrap{padding:0 40px}}

/* 節の頭。等幅の英字ラベルと明朝の見出し */
.hp .hx-k{--font-body-ja:var(--mono);margin:0;font-size:12px;font-weight:600;letter-spacing:.06em;line-height:1.4;color:var(--blue)}
.hp .hx-dark .hx-k{color:var(--blue-soft)}
/* 青い旗の札。両端が旗のように切れる。値は LP の Ribbon (t2-parts.tsx)。白の太字は OS のゴシック */
.hp .hx-flag{--font-body-ja:var(--gothic);display:block;width:fit-content;max-width:100%;margin:0;padding:4px 16px;background:var(--blue);color:#fff;font-weight:900;font-size:13px;line-height:1.6;letter-spacing:.04em;clip-path:polygon(0 0,100% 0,calc(100% - 8px) 50%,100% 100%,0 100%,8px 50%)}
.hp .hx-flag-ic{display:inline-block;width:1.05em;height:1.05em;margin:0 6px 0 -2px;vertical-align:-.14em}
.hp .hx-flag+.hx-h2{margin-top:12px}
@media (min-width:768px){.hp .hx-flag{font-size:15px}}
/* 箱の見出し。最初の画面 (HeroEditorial) の黄の箱と同じ作り。墨の字に黄の箱で、行ごとに箱。中央そろえ。箱の中で折り返す */
.hp .hx-head-c,.hp .hx-note-c{text-align:center}
.hp .hx-head-c .hx-flag{margin-left:auto;margin-right:auto}
.hp .hx-head-c .hx-lede{margin-left:auto;margin-right:auto}
.hp .hx-h2.hx-bands{--font-body-ja:var(--mincho);display:flex;flex-direction:column;align-items:center;gap:8px;font-weight:var(--h2-w);font-size:var(--h2-l);line-height:1.45;letter-spacing:.04em;word-break:auto-phrase;overflow-wrap:anywhere}
.hp .hx-bands>span{max-width:100%;padding:2px .4em;background:var(--yellow);color:var(--black);text-align:center}
@media (min-width:900px){.hp .hx-h2.hx-bands{gap:10px}}
.hp .hx-h2{--font-body-ja:var(--mincho);margin:8px 0 0;font-weight:var(--h2-w);font-size:var(--h2-l);line-height:1.45;letter-spacing:-.02em;word-break:auto-phrase;color:inherit}
.hp .hx-h2.hx-h2-s{font-size:var(--h2-s)}
/* 常識を赤線で消す見出し。消す言葉は del (灰に赤の斜線)、答えは mark.hx-hl (黄のマーカー)、下に赤字の1行。明るい面だけで使う。
   hx-brs はスマホだけの改行。PC は2行にまとまる。語のまとまりは nowrap で割らない */
.hp .hx-h2.hx-strike{letter-spacing:.02em}
.hp .hx-strike del{position:relative;text-decoration:none;white-space:nowrap;color:color-mix(in srgb,var(--sub) 75%,#fff)}
.hp .hx-strike del::after{content:"";position:absolute;left:-4%;right:-4%;top:52%;height:.14em;background:var(--red);transform:rotate(-6deg);border-radius:2px}
.hp .hx-strike mark,.hp .hx-strike .hx-nw{white-space:nowrap}
.hp .hx-caret{margin:8px 0 0;font-size:12px;font-weight:700;line-height:1.6;letter-spacing:.02em;color:var(--ink)}
@media (min-width:768px){.hp .hx-caret{font-size:14px}.hp .hx-brs{display:none}}
@media (min-width:900px){.hp .hx-h2{line-height:1.4}}
.hp .hx-lede{margin-top:16px;max-width:680px;font-weight:700}
.hp .hx-note{margin-top:8px;font-size:13px;line-height:1.7;color:var(--sub)}
.hp .hx-dark .hx-note{color:rgba(255,255,255,.72)}

/* リンクとフォーカス。明るい面は青の輪、黒の面は白の輪 */
.hp .hx-sec a:focus-visible,.hp .hx-sec button:focus-visible{outline:2px solid var(--focus-ring);outline-offset:2px}
.hp .hx-tlink{font-weight:700;font-size:15px;color:inherit;text-underline-offset:5px;text-decoration-thickness:1px;text-decoration-line:underline}
@media (hover:hover){.hp .hx-tlink:hover{text-decoration-thickness:2px;text-underline-offset:4px}}

/* 申し込みの札。ブランド広告と同じ角丸 16px と右向きの矢印。黒の面は白の塗りに墨の字、明るい面は墨の塗りに白の字 */
.hp .hx-pill{--font-body-ja:var(--gothic);display:inline-flex;align-items:center;gap:14px;min-height:52px;padding:0 26px;border-radius:16px;font-weight:700;font-size:17px;letter-spacing:.04em;white-space:nowrap;text-decoration:none;transition:background-color var(--m-cta) var(--m-out)}
.hp .hx-pill-onDark{background:#fff;color:var(--black)}
.hp .hx-pill-onDark:hover{background:#E6E6E2}
.hp .hx-pill-onLight{background:var(--ink);color:#fff}
.hp .hx-pill-onLight:hover{background:#000}
.hp .hx-arrow{width:30px;height:18px;flex:none;transition:transform var(--m-cta) var(--m-out)}
.hp .hx-pill:hover .hx-arrow{transform:translateX(var(--m-arrow-x))}
@media (min-width:768px){.hp .hx-pill{min-height:60px;font-size:18px}}

/* ブラウザの窓の枠。学習サイトの本当の画面や表を入れる */
.hp .hx-frame{border:1px solid var(--ink);border-radius:6px;overflow:hidden;background:#fff}
.hp .hx-frame-bar{display:flex;align-items:center;gap:6px;padding:9px 12px;border-bottom:1px solid var(--ink);font-size:12px;line-height:1.4;color:var(--sub);background:#fff}
.hp .hx-frame-bar i{width:9px;height:9px;border-radius:50%;border:1px solid var(--ink);flex:none}
.hp .hx-frame-label{margin-left:8px;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}

/* 端から端までの写真の帯。字を重ねるときだけ、字の下を暗くする */
.hp .hx-band{position:relative;margin:0;height:280px;overflow:hidden;background:var(--black)}
.hp .hx-band img{display:block;width:100%;height:100%;object-fit:cover;object-position:var(--focus,50% 35%)}
.hp .hx-band-shade::after{content:"";position:absolute;inset:0;background:linear-gradient(to top,rgba(14,14,16,.84),rgba(14,14,16,0) 66%)}
.hp .hx-band-in{position:absolute;left:0;right:0;bottom:24px;z-index:2}
.hp .hx-band-line{--font-body-ja:var(--mincho);color:#fff;font-weight:700;font-size:clamp(20px,5.4vw,30px);line-height:1.55;letter-spacing:.02em;word-break:keep-all}
.hp .hx-band-credit{margin-top:8px;font-size:12px;line-height:1.5;color:rgba(255,255,255,.86)}
@media (min-width:768px){.hp .hx-band{height:380px}.hp .hx-band-in{bottom:40px}}
@media (min-width:1200px){.hp .hx-band{height:440px}}

/* 大きな引用と、並べる引用 */
.hp .hx-pull{margin:var(--gap) 0 0;border-top:1px solid var(--ink);padding-top:24px}
.hp .hx-pull blockquote{--font-body-ja:var(--mincho);margin:0;font-weight:700;font-size:clamp(22px,6.4vw,28px);line-height:1.6;letter-spacing:.02em}
.hp .hx-pull blockquote strong{font-weight:600}
.hp .hx-who{margin-top:12px;font-size:13px;line-height:1.6;color:var(--sub)}
@media (min-width:900px){.hp .hx-pull blockquote{font-size:34px}}
.hp .hx-qi{margin:0;padding:18px 0;border-bottom:1px solid #C9CFDA}
.hp .hx-qi-tp{margin:0;font-size:12px;font-weight:600;line-height:1.5;color:var(--blue)}
.hp .hx-qi-tp::before{content:"";display:inline-block;width:8px;height:8px;margin-right:8px;background:var(--blue)}
.hp .hx-qi blockquote{margin:6px 0 0;font-size:14px;line-height:1.85}
.hp .hx-qi strong{font-weight:900;background:linear-gradient(transparent 70%,#BFD1F7 70%)}
.hp .hx-qi .hx-who{margin-top:4px;font-size:12px}

/* 署名とロゴ。黒の面の締めに置く */
.hp .hx-sign{display:flex;align-items:center;gap:18px;margin:0}
.hp .hx-sign span{--font-body-ja:var(--mincho);font-weight:700;font-size:20px;letter-spacing:.08em;color:#fff}
.hp .hx-sign img{height:18px;width:auto;filter:brightness(0) invert(1)}

@media (prefers-reduced-motion:reduce){.hp .hx-arrow{transition:none}}
${planColorCss(".hp")}
`;
